'use strict';

// Edits one TabularDuctData calc element as a single grid: the first grid row is the
// column headers (columns[].value), every other grid row is one stored row (rows[].cells[].value).
angular.module('enervexSalesappApp').controller('TabularDuctDataCtrl', function($scope, TabularDuctData, DuctDataGridUtil, $stateParams, Flash, $state, _) {
	$scope.ctx = {
		formChanged: false,
		showPaste: false,
		pasteText: ''
	};

	$scope.types = DuctDataGridUtil.types;

	function load(item) {
		$scope.item = item;
		if (!$scope.item.ductDataType) {
			$scope.item.ductDataType = 'other';
		}
		$scope.grid = DuctDataGridUtil.toGrid(item);
		$scope.describe();
		$scope.ctx.formChanged = false;
	}

	// axis labels for the current type / code
	$scope.describe = function() {
		$scope.meta = DuctDataGridUtil.describe($scope.item.ductDataType, $scope.item.code);
	};
	$scope.isKeyColumn = function(c) {
		return $scope.meta && c < $scope.meta.keyColumns;
	};
	// value columns the calculation never reads directly (outside the clamped range)
	$scope.isUnusedColumn = function(c) {
		var range = $scope.meta && $scope.meta.usedRange;
		if (!range || $scope.isKeyColumn(c)) return false;
		var v = $scope.grid[0][c];
		return _.isNumber(v) && (v < range[0] || v > range[1]);
	};
	$scope.valueColumns = function() {
		return Math.max($scope.width() - (($scope.meta && $scope.meta.keyColumns) || 0), 0);
	};

	if ($stateParams.id == "new") {
		load({
			code: '',
			ventbomCode: '',
			ductDataType: 'other',
			columns: [{ value: 0 }, { value: null }],
			rows: [{ cells: [{ value: null }, { value: null }] }]
		});
	} else {
		TabularDuctData.get({
			id: $stateParams.id
		}).$promise.then(load);
	}

	$scope.width = function() {
		return ($scope.grid && $scope.grid[0]) ? $scope.grid[0].length : 0;
	};
	$scope.changed = function() {
		$scope.ctx.formChanged = true;
	};
	$scope.addRow = function(index) {
		$scope.grid.splice(index + 1, 0, _.times($scope.width(), function() {
			return null;
		}));
		$scope.changed();
	};
	$scope.removeRow = function(index) {
		if (index == 0) return; // header row
		$scope.grid.splice(index, 1);
		$scope.changed();
	};
	$scope.addColumn = function(index) {
		_.each($scope.grid, function(r) {
			r.splice(index + 1, 0, null);
		});
		$scope.changed();
	};
	$scope.removeColumn = function(index) {
		if ($scope.width() <= 1) return;
		_.each($scope.grid, function(r) {
			r.splice(index, 1);
		});
		$scope.changed();
	};
	$scope.openPaste = function() {
		$scope.ctx.pasteText = DuctDataGridUtil.toText($scope.grid);
		$scope.ctx.showPaste = true;
	};
	$scope.applyPaste = function() {
		var grid = DuctDataGridUtil.parse($scope.ctx.pasteText);
		if (grid.length == 0) {
			Flash.create('danger', '<strong>Error!</strong> Nothing to paste', 0, {}, true);
			return;
		}
		$scope.grid = grid;
		$scope.ctx.showPaste = false;
		$scope.changed();
	};

	function validate() {
		if (!$scope.item.code || $scope.item.code == '') {
			return "Code is required";
		}
		if ($scope.grid.length < 2 || $scope.width() == 0) {
			return "The table needs a header row and at least one data row";
		}
		var blank = null;
		_.each($scope.grid, function(r, ri) {
			_.each(r, function(v, ci) {
				if (!blank && !(_.isNumber(v) && !_.isNaN(v))) {
					blank = (ri == 0 ? "header" : "row " + ri) + ", column " + (ci + 1);
				}
			});
		});
		if (blank) {
			return "Every cell must be a number (" + blank + ")";
		}
		return null;
	}

	$scope.save = function() {
		Flash.clear();
		// key columns' header cells are not editable (hidden); the lookup ignores them, store 0
		_.each($scope.grid[0], function(v, c) {
			if ($scope.isKeyColumn(c) && !_.isNumber(v)) {
				$scope.grid[0][c] = 0;
			}
		});
		var message = validate();
		if (message) {
			Flash.create('danger', '<strong>Error!</strong> ' + message, 0, {}, true);
			return;
		}
		var payload = _.omit(_.clone($scope.item), "__v", "type");
		_.extend(payload, DuctDataGridUtil.fromGrid($scope.grid, $scope.item));
		var p = $scope.item._id ? TabularDuctData.update({ id: $scope.item._id }, payload).$promise : TabularDuctData.save(payload).$promise;
		p.then(function(result) {
			Flash.create('success', '<strong>Success!</strong> Saved ' + result.code + '.', 0, {}, true);
			if (!$scope.item._id) {
				$state.go("tabular-duct-data", { id: result._id }, { inherit: false, reload: true });
			} else {
				load(result);
			}
		}).catch(function(err) {
			var message = (err.data && err.data.message) || "There was an error saving";
			Flash.create('danger', '<strong>Error!</strong> ' + message, 0, {}, true);
		});
	};
});
